<div *ngIf="mode === 'view'" class="field field_size_{{ size }}">
  <div *ngIf="name" class="field__name">{{ name }} &nbsp;</div>
  <tui-files>
    <tui-file
      *ngFor="let file of tuiFiles"
      class="file size_{{ size }}"
      [file]="file"
      [leftContent]="content"
      (click)="downloadDocument(file.id)"
    ></tui-file>
  </tui-files>
</div>

<ng-template #content>
  <tui-icon icon="@tui.download" [style.font-size.rem]="1"></tui-icon>
</ng-template>
